import BaseAPI from "../base";
class HisService extends BaseAPI {
  mainMethod(params) {
    return this.post({
      url: `${process.env.VUE_APP_HIS_APIBASEURL}/MainEntrance/MainMethod`,
      data: {
        msg_id: "",
        access_token: "Circle_Health_761C12E9",
        ...params,
      },
    });
  }
  uploadFile(params) {
    return this.post({
      url: `${process.env.VUE_APP_HIS_APIBASEURL}/UploadPdfFile/UploadPayUploadPayVoucher`,
      data: {
        ...params,
      },
    });
  }
  queryDailyReportData(params) {
    return this.post({
      url: `${process.env.VUE_APP_MG_APIBASEURL}/Operate/QueryDailyReportData`,
      data: {
        ...params,
      },
    });
  }
  queryMerchantCustomerList(params) {
    return this.post({
      url: `${process.env.VUE_APP_MG_APIBASEURL}/Operate/QueryMerchantCustomerList`,
      data: {
        ...params,
      },
    });
  }
  queryMerchantCustomerDict(params) {
    return this.post({
      url: `${process.env.VUE_APP_MG_APIBASEURL}/Operate/QueryMerchantCustomerDict?key=QMCD%4020230919`,
      data: {
        ...params,
      },
    });
  }
  cardInfoWeb(params) {
    return this.post({
      url: `${process.env.VUE_APP_MG_APIBASEURL}/Card/CardInfo_Web`,
      data: {
        ...params,
      },
    });
  }
}

export default new HisService();
